import { useNavigate } from 'react-router-dom';
import Chatbot from '../components/Chatbot';
import { ROUTES } from '../navigation';

function ChatPage() {
  const navigate = useNavigate();

  return (
    <Chatbot
      isOpen={true}
      onClose={() => navigate(ROUTES.HELP)}
    />
  );
}

export default ChatPage;
